import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['id', 'pmcSelect', 'communities', 'communitiesSelect', 'communitiesEdit', 'submit']

  connect() {
    this.fireNativeEvent()
    if(this.pmcSelectTarget.value) {
      this.getCommunities(this.idTarget.value, this.pmcSelectTarget.value)
    }
  }

  fireNativeEvent() {
    $(this.pmcSelectTarget).on('select2:select', function () {
      let event = new Event('change', { bubbles: true }) // fire a native event
      this.dispatchEvent(event)
    })
  }

  showCommunities() {
    if (this.pmcSelectTarget.value) {
      this.communitiesSelectTarget.style.display = 'block'
      this.submitTarget.style.display = 'block'
    } else {
      this.communitiesSelectTarget.style.display = 'none'
      this.submitTarget.style.display = 'none'
    }
  }

  selectCorporation(e) {
    this.getCommunities(this.idTarget.value, e.target.value)
  }

  getCommunities(contactId, corporationId) {
    $.get({
      url: '/contacts/communities',
      data: { corporation_id: corporationId, id: contactId },
      success: (results) => {
        this.communitiesEditTarget.style.display = 'none'
        this.showCommunities()
        this.communitiesTarget.innerHTML = results
      }
    })
  }
}
